import { Project } from "../models/project";
import { API_URL } from "./apiBase";

export async function ProjectSubmit(
  url: string,
  accessToken: string,
  body: Project
) {
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(String(errorData.message)  || "Failed to submit project");

  }

  return response.json();
}

export async function createProjectSubmit(accessToken: string, body: Project) {
  return ProjectSubmit(`${API_URL}/projects/`, accessToken, body);
}

export async function updateProjectSubmit(
  project_id: string,
  accessToken: string,
  body: Project
) {
  return ProjectSubmit(`${API_URL}/projects/${project_id}`, accessToken, body);
}
